
import React, { ReactNode, useEffect } from "react";
import { IntlProvider, MessageFormatElement } from "react-intl";
import { useConfigStore } from "./store/store";

interface I18nProps {
    children: ReactNode;
}

export const I18n: React.FC<I18nProps> = ({ children }) => {
    const { translations, language } = useConfigStore();

    return (
        <IntlProvider
            messages={translations as Record<string, string> | Record<string, MessageFormatElement[]>}
            locale={language}
            key={language}
        >
            {children}
        </IntlProvider>
    );
};
